<template>
  <div class="panel" :class="getClass">
    <div class="panel-data">
      <h3>{{ panel_data.heading }}</h3>
      <p>
        {{ panel_data.brief_description }}
      </p>
      <a
        target="_blank" 
        rel="noopener noreferrer"
        class="panel-data__button"
        :href="panel_data.button_link"
        v-if="panel_data.button_text"
        >{{ panel_data.button_text }}</a
      >
    </div>
    <div class="panel-image">
      <img :src="panel_data.image" v-if="panel_data.image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: {
    panel_data: undefined,
  },
  computed: {
    getClass: function () {
      switch (this.panel_data.image_align) {
        case "right":
          return "image-right";
        case "left":
          return "image-left";
        case "top":
          return "image-top";
        case "bottom":
          return "image-bottom";
        default:
          return "no-image";
      }
    },
  },
  data() {
    return {};
  },
  methods: {},
  updated() {},
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";
.panel {
  display: flex;
  padding: 1rem 0;

  &.image-right {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

    .panel-data {
      padding-right: 20px;
      width: 70%;

      @media screen and (max-width: 767px) {
        width: 100%;
        padding-bottom: 20px;
        padding-right: 0;
      }
    }

    .panel-data__button {
      display: inline-block;
      padding: 1rem 3rem;
      margin: 0.5rem 0;
      border: 2px solid #1a2a40;
      color: #1a2a40;
      font-weight: bold;
      @media screen and (max-width: 767px) {
        display: block;
        text-align: center;
      }
    }

    .panel-image {
      width: 30%;
      text-align: center;

      img {
        max-height: 250px;
        height: 100%;
        width: auto;
      }

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }

  &.image-left {
    flex-direction: row-reverse;

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

    .panel-data {
      padding-left: 20px;
      width: 70%;

      @media screen and (max-width: 767px) {
        width: 100%;
        padding-bottom: 20px;
        padding-left: 0;
      }
    }

    .panel-image {
      width: 30%;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }

  &.image-top {
    flex-direction: column-reverse;

    .panel-data {
      padding-top: 20px;
    }
  }

  &.image-bottom {
    flex-direction: column;

    .panel-data {
      padding-bottom: 20px;
    }
  }

  &.no-image {
    .panel-image {
      display: none;
    }
  }

  .panel-image {
    img {
      width: 100%;
    }
  }
}
</style>
